import { ChatMessageKey } from './EntityKeys';

export interface SummarizeMessage {
    summary: string;
    summarizeStartAt: Date;
    summarizeEndAt: Date;
    numberOfMessagesSummarized: number;
    lastSummarizedMessageKey: ChatMessageKey;
}

export enum SummaryOption {
    Unread = 'unread',
    Today = 'today',
    Yesterday = 'yesterday',
    Last7Days = 'last7Days',
    Last14Days = 'last14Days',
    Last30Days = 'last30Days',
}

export interface SummarizeOptionValue {
    from: string | null;
    to: string | null;
    read?: 'true' | 'false' | null;
}
